enum HamburgerMenuActionType {
    TOGGLE_HAMBURGER_MENU = "TOGGLE_HAMBURGER_MENU",
}

export default HamburgerMenuActionType;
